import axios from 'axios';

const httpClient = axios.create({
  baseURL: `https://app.${window.location.host}/api/borrower/api/v1`
})

export { httpClient }